module.exports = __webpack_public_path__ + "img/LOGO.8aa717ac.png";